import { useEffect, useRef, useState } from 'react';
import type { OccurrenceStepEnum } from '../../../enums/occurrenceStep';
import type { OccurrenceWithTimeSpent } from '../../../models/occurrence';

interface ITrackingLoadStateInput {
    listLoading: boolean;
    loadingTimeSpent: boolean;
    stepTypeCurrentFilter: OccurrenceStepEnum | null;
    currentList: OccurrenceWithTimeSpent[];
}

const useTrackingLoadState = ({
    listLoading,
    loadingTimeSpent,
    stepTypeCurrentFilter,
    currentList,
}: ITrackingLoadStateInput) => {
    const [loadedOnce, setLoadedOnce] = useState(false);
    const [statsLoadedOnce, setStatsLoadedOnce] = useState(false);
    const [stageBaseline, setStageBaseline] = useState<OccurrenceWithTimeSpent[]>([]);
    const sawLoading = useRef(false);

    useEffect(() => {
        if (listLoading) {
            sawLoading.current = true;
            return;
        }
        if (sawLoading.current) {
            setLoadedOnce(true);
            if (!loadingTimeSpent) {
                setStatsLoadedOnce(true);
            }
        }
    }, [listLoading, loadingTimeSpent]);

    useEffect(() => {
        if (!stepTypeCurrentFilter) {
            setStageBaseline(currentList);
        }
    }, [currentList]);

    const statsLoading = listLoading || loadingTimeSpent;
    const stageList = (stepTypeCurrentFilter || statsLoading) && stageBaseline.length ? stageBaseline : currentList;

    return { loadedOnce, statsLoadedOnce, statsLoading, stageList };
};

export default useTrackingLoadState;
